import { FC, MouseEventHandler } from 'react';
import { Browser } from '@capacitor/browser';
import { SxProps } from '@mui/material';
import i18n from 'i18next';

import { AppStoreDe } from './assets/app-store-de';
import { AppStoreEn } from './assets/app-store-en';
import googlePlayBadgeDe from './assets/google-play-badge-de.png';
import googlePlayBadgeEn from './assets/google-play-badge-en.png';
import {
	StoreBadgesContainer,
	StoreBadgesGoogPlayImage,
	StoreBadgesImageWrapper,
} from './StoreBadges.styles';

interface StoreBadgesProps {
	iosLink: string;
	androidLink: string;
	sx?: SxProps;
}

export const StoreBadges: FC<StoreBadgesProps> = ({
	iosLink,
	androidLink,
	sx,
}) => {
	const isDE = i18n.language === 'de';

	const handleOpenStore: (url: string) => MouseEventHandler<HTMLDivElement> =
		(url) => (e) => {
			e.preventDefault();
			Browser.open({ url });
		};

	return (
		<StoreBadgesContainer data-testid="storeBadges-container" sx={sx}>
			<StoreBadgesImageWrapper
				data-testid="storeBadges-ios-imgWrapper"
				onClick={handleOpenStore(iosLink)}
			>
				{isDE ? (
					<AppStoreDe data-testid="storeBadges-ios-badge-de" />
				) : (
					<AppStoreEn data-testid="storeBadges-ios-badge-en" />
				)}
			</StoreBadgesImageWrapper>
			<StoreBadgesImageWrapper
				data-testid="storeBadges-android-imgWrapper"
				onClick={handleOpenStore(androidLink)}
			>
				<StoreBadgesGoogPlayImage
					src={isDE ? googlePlayBadgeDe : googlePlayBadgeEn}
					alt="Google Play badge"
					data-testid={`storeBadges-android-badge-${isDE ? 'de' : 'en'}`}
				/>
			</StoreBadgesImageWrapper>
		</StoreBadgesContainer>
	);
};
